
// import React, { useEffect, useMemo, useState } from "react";
// import styled from "styled-components";
// import { useParams, useNavigate } from "react-router-dom";
// import { FaArrowLeft } from "react-icons/fa";
// import Navbar from "./Navbar";
// import DashboardHeader from "./DashboardHeader";
// import Footer from "./Footer";
// import api from "../api";
// import { useTheme } from "../App"; // 🔥 Import the global theme hook



// /* ================= PAGE LAYOUT & THEME VARIABLES ================= */
// const Container = styled.div`
//   --sidebar-expanded: 260px;
//   --sidebar-collapsed: 90px;
  
//   /* 🔥 THEME VARIABLES 🔥 */
//   --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
//   --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.94)'};
//   --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
//   --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
//   --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};
//   --input-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'};
//   --input-border: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e5e7eb'};
//   --table-header-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#f8fafc'};
//   --table-border: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e2e8f0'};
  
//   /* Custom Purple/Green Theme Vars for this page */
//   --eval-th-bg: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(139, 92, 246, 0.1)' : '#f5f3ff'};
//   --eval-border: ${({ $isDarkMode }) => $isDarkMode ? '#4c1d95' : '#ede9fe'};
//   --serial-bg: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(139, 92, 246, 0.15)' : '#f5f3ff'};
//   --attr-bg: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(139, 92, 246, 0.1)' : '#f5f3ff'};
//   --calc-staff-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(135deg, #2e1065 0%, #4c1d95 100%)' : 'linear-gradient(135deg, #faf5ff 0%, #f5f3ff 100%)'};
//   --calc-sup-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(135deg, #064e3b 0%, #14532d 100%)' : 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)'};

//   --primary: #7c3aed;
//   --primary-dark: #6d28d9;
//   --accent: #8b5cf6;
//   --shadow-lg: 0 22px 55px rgba(0, 0, 0, 0.15);
//   --shadow-md: 0 12px 30px rgba(0, 0, 0, 0.1);

//   min-height: 100vh;
//   background: var(--page-bg);
//   color: var(--text-main);
//   margin-left: ${({ collapsed }) =>
//     collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
//   transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;

//   @media (max-width: 1024px) {
//     margin-left: ${({ collapsed }) => (collapsed ? "78px" : "220px")};
//   }

//   @media (max-width: 768px) {
//     margin-left: 0;
//   }
// `;

// const Main = styled.main`
//   width: min(1380px, calc(100% - 32px));
//   margin: 0 auto;
//   padding: 12px 0 40px;

//   @media (max-width: 1024px) {
//     width: min(100%, calc(100% - 24px));
//     padding: 12px 0 32px;
//   }

//   @media (max-width: 576px) {
//     width: min(100%, calc(100% - 16px));
//     padding: 12px 0 24px;
//   }
// `;

// /* ================= HERO GRID ================= */
// const Hero = styled.section`
//   display: grid;
//   grid-template-columns: 1.35fr 0.95fr;
//   gap: 24px;
//   margin-bottom: 24px;

//   @media (max-width: 992px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const HeroPanel = styled.div`
//   background: linear-gradient(135deg, #0f172a 0%, #312e81 50%, #7c3aed 100%);
//   color: white;
//   padding: 28px;
//   border-radius: 28px;
//   box-shadow: var(--shadow-lg);
//   position: relative;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   height: 100px;
//   &::before {
//     content: "";
//     position: absolute;
//     right: -30px;
//     bottom: -60px;
//     width: 180px;
//     height: 180px;
//     border-radius: 50%;
//     background: rgba(255, 255, 255, 0.08);
//   }

//   @media (max-width: 576px) {
//     padding: 22px 18px;
//     border-radius: 22px;
//   }
// `;

// const HeroTitle = styled.h1`
//   margin: 0;
//   font-size: clamp(1.6rem, 1.2rem + 1.5vw, 2.5rem);
//   line-height: 1.1;
//   font-weight: 800;
//   margin-bottom: 3px;
//   position: relative;
//   z-index: 1;
// `;

// const HeroText = styled.p`
//   margin: 0;
//   color: rgba(255, 255, 255, 0.9);
//   line-height: 1.65;
//   font-size: 1.05rem;
//   max-width: 720px;
//   position: relative;
//   z-index: 1;
// `;





// /* Custom Select Dropdown - Compact & No Scroll */
// const DropdownContainer = styled.div`
//   position: relative;
//   width: ${({ width }) => width || "90px"};
//   outline: none;
//   z-index: ${({ $isOpen }) => ($isOpen ? 9999 : 1)};
// `;

// const DropdownSelected = styled.div`
//   width: 100%;
//   padding: 4px 6px; 
//   border-radius: 6px; 
//   border: 1px solid ${({ $isOpen, $isDarkMode }) => ($isOpen ? "#c4b5fd" : $isDarkMode ? "#334155" : "#dbe3ef")};
//   background: ${({ $disabled, $isDarkMode }) => ($disabled ? ($isDarkMode ? "var(--border)" : "#f8fafc") : "var(--input-bg)")};
//   color: ${({ $disabled, $isDarkMode }) => ($disabled ? "var(--text-soft)" : "var(--text-main)")};
//   font-size: 0.75rem; 
//   cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 4px;
//   box-shadow: ${({ $isOpen }) => ($isOpen ? "0 0 0 3px rgba(139, 92, 246, 0.12)" : "none")};
//   transition: border-color 0.2s ease, box-shadow 0.2s ease;

//   span:first-child {
//     white-space: nowrap;
//     overflow: hidden;
//     text-overflow: ellipsis;
//   }
//   span:last-child { flex-shrink: 0; }
// `;

// const DropdownMenu = styled.div`
//   position: absolute;
//   top: calc(100% + 4px);
//   left: 0;
//   width: max-content;
//   min-width: 100%;
//   max-width: 180px; 
//   background: var(--card-bg);
//   border: 1px solid var(--border);
//   border-radius: 6px; 
//   box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
//   z-index: 999;
// `;

// const DropdownItem = styled.div`
//   padding: 6px 8px; 
//   font-size: 0.75rem; 
//   color: var(--text-main);
//   cursor: pointer;
//   border-bottom: 1px solid var(--border);

//   &:last-child { border-bottom: none; }
//   &:hover { background: var(--table-header-bg); color: #8b5cf6; font-weight: 600; }
// `;

// const CustomSelect = ({ value, onChange, options, disabled, width, isDarkMode }) => {
//   const [isOpen, setIsOpen] = useState(false);

//   return (
//     <DropdownContainer width={width} tabIndex={disabled ? -1 : 0} onBlur={() => setIsOpen(false)} $isOpen={isOpen}>
//       <DropdownSelected $disabled={disabled} $isOpen={isOpen} $isDarkMode={isDarkMode} onClick={() => !disabled && setIsOpen(!isOpen)}>
//         <span>{value === "" ? "Select" : value}</span>
//         <span style={{ fontSize: "8px", color: "var(--text-soft)" }}>▼</span>
//       </DropdownSelected>
//       {isOpen && (
//         <DropdownMenu>
//           {options.map((opt) => (
//             <DropdownItem
//               key={opt.value}
//               onMouseDown={(e) => {
//                 e.preventDefault(); 
//                 onChange(opt.value);
//                 setIsOpen(false);
//               }}
//             >
//               {opt.label}
//             </DropdownItem>
//           ))}
//         </DropdownMenu>
//       )}
//     </DropdownContainer>
//   );
// };

// const Textarea = styled.textarea`
//   width: 100%;
//   min-height: 60px;
//   padding: 8px;
//   border: 1px solid var(--input-border);
//   border-radius: 8px;
//   resize: vertical;
//   font-size: 0.85rem;
//   line-height: 1.4;
//   background: ${({ readOnly }) => (readOnly ? "var(--border)" : "var(--input-bg)")};
//   color: ${({ $textColor, readOnly }) => readOnly ? "var(--text-soft)" : $textColor || "var(--text-main)"};
//   outline: none;
//   box-sizing: border-box;
//   transition: all 0.2s;

//   &:focus {
//     border-color: #c4b5fd;
//     box-shadow: ${({ readOnly }) => (readOnly ? "none" : "0 0 0 3px rgba(139, 92, 246, 0.12)")};
//   }

//   &:read-only { cursor: not-allowed; }
// `;

// const CommentLabel = styled.div`
//   font-size: 10px;
//   font-weight: 800;
//   text-transform: uppercase;
//   letter-spacing: 0.05em;
//   color: ${({ $color }) => $color || "var(--text-soft)"};
//   margin-bottom: 4px;
//   margin-top: ${({ $marginTop }) => $marginTop || "0"};
// `;

// /* ================= MOBILE ================= */
// const MobileGrid = styled.div`
//   display: none;
//   @media (max-width: 1024px) {
//     display: grid;
//     gap: 16px;
//   }
// `;

// const MobileCard = styled.div`
//   background: var(--input-bg);
//   border: 1px solid var(--border);
//   border-radius: 20px;
//   padding: 16px;
//   box-shadow: 0 8px 22px rgba(0, 0, 0, 0.05);
// `;

// const MobileTop = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 12px;
//   margin-bottom: 14px;
// `;

// const MobileAttributeTitle = styled.div`
//   font-weight: 800;
//   font-size: 15px;
//   color: ${({ $isDarkMode }) => $isDarkMode ? '#c4b5fd' : '#4c1d95'};
// `;

// const Label = styled.div`
//   font-size: 11px;
//   font-weight: 800;
//   margin-top: 16px;
//   margin-bottom: 6px;
//   color: var(--text-soft);
//   text-transform: uppercase;
//   letter-spacing: 0.04em;
// `;

// const ReadOnlyField = styled.div`
//   padding: 12px 14px;
//   border-radius: 10px;
//   background: var(--table-header-bg);
//   border: 1px solid var(--table-border);
//   color: var(--text-main);
//   font-size: 0.85rem;
//   line-height: 1.5;
// `;

// /* ================= BOTTOM SECTION ================= */
// const CardSub = styled.p`
//   margin: 0 0 16px;
//   color: var(--text-soft);
//   line-height: 1.6;
//   font-size: 0.94rem;
// `;

// const CalcGrid = styled.div`
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   gap: 20px;
//   margin-bottom: 24px;

//   @media (max-width: 768px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const CalcBox = styled.div`
//   background: ${({ variant }) => 
//     variant === "supervisor" 
//       ? "var(--calc-sup-bg)" 
//       : "var(--calc-staff-bg)"};
//   padding: 22px;
//   border-radius: 22px;
//   border-left: 5px solid ${({ variant }) => (variant === "supervisor" ? "#16a34a" : "#7c3aed")};
//   line-height: 1.75;
//   box-shadow: 0 10px 22px rgba(0, 0, 0, 0.05);
// `;

// const CalcTitle = styled.div`
//   font-size: 1rem;
//   font-weight: 800;
//   color: ${({ variant, $isDarkMode }) => variant === "supervisor" ? ($isDarkMode ? '#4ade80' : '#16a34a') : ($isDarkMode ? '#c4b5fd' : '#4c1d95')};
//   margin-bottom: 8px;
// `;

// const CalcLine = styled.div`
//   color: ${({ variant, $isDarkMode }) => variant === "supervisor" ? ($isDarkMode ? '#86efac' : '#15803d') : ($isDarkMode ? '#ddd6fe' : '#5b21b6')};
//   font-size: 0.96rem;
// `;

// const FinalScoreWrapper = styled.div`
//   display: flex;
//   gap: 20px;
//   margin-bottom: 32px;
  
//   @media (max-width: 600px) { 
//     flex-direction: column; 
//   }
// `;

// const FinalScoreCard = styled.div`
//   flex: 1;
//   background: var(--input-bg);
//   border: 1px solid var(--border);
//   padding: 32px 24px;
//   border-radius: 12px;
//   text-align: center;
//   box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
// `;

// const FinalScoreLabel = styled.div`
//   font-size: 13px;
//   font-weight: 800;
//   color: var(--text-soft);
//   text-transform: uppercase;
//   letter-spacing: 0.05em;
// `;

// const FinalScoreValue = styled.div`
//   font-size: 42px;
//   font-weight: 900;
//   margin-top: 12px;
//   color: ${({ variant, $isDarkMode }) => (variant === "supervisor" ? ($isDarkMode ? "#4ade80" : "#16a34a") : ($isDarkMode ? "#a855f7" : "#7c3aed"))};
// `;

// const ActionWrap = styled.div`
//   display: flex;
//   width: 100%;
// `;

// const Button = styled.button`
//   appearance: none; border: none; outline: none; border-radius: 22px; padding: 18px 36px;
//   width: 100%; background: ${({ disabled, success }) =>
//     disabled && !success ? "linear-gradient(135deg, #94a3b8, #cbd5e1)" : "linear-gradient(135deg, #7c3aed, #8b5cf6)"};
//   color: white; font-size: 1.05rem; font-weight: 800; cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
//   box-shadow: ${({ disabled, success }) => disabled && !success ? "none" : "0 14px 28px rgba(139, 92, 246, 0.22)"};
//   transition: transform 0.2s ease, box-shadow 0.2s ease;

//   &:hover {
//     transform: ${({ disabled }) => (disabled ? "none" : "translateY(-2px)")};
//     box-shadow: ${({ disabled, success }) => disabled && !success ? "none" : "0 18px 30px rgba(139, 92, 246, 0.28)"};
//   }
// `;

// /* ================= MODAL ================= */
// const ModalOverlay = styled.div`
//   position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
//   background: rgba(15, 23, 42, 0.4); backdrop-filter: blur(6px);
//   display: flex; justify-content: center; align-items: center; z-index: 9999; padding: 20px;
//   animation: fadeIn 0.2s ease-out;
// `;

// const ModalBox = styled.div`
//   background: var(--card-bg); border-radius: 24px; padding: 32px; width: min(100%, 440px);
//   box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5); border: 1px solid var(--border);
//   animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
// `;

// const ModalIcon = styled.div`
//   width: 54px; height: 54px; border-radius: 50%; background: rgba(217, 119, 6, 0.1); color: #d97706;
//   display: flex; align-items: center; justify-content: center; font-size: 24px; margin: 0 auto 20px;
// `;

// const ModalTitle = styled.h3` margin: 0 0 12px; font-size: 1.35rem; font-weight: 800; color: var(--text-main); `;
// const ModalText = styled.p` margin: 0 0 28px; color: var(--text-soft); line-height: 1.6; font-size: 0.95rem; `;
// const ModalActions = styled.div` display: flex; gap: 12px; justify-content: flex-end; @media (max-width: 480px) { flex-direction: column-reverse; } `;
// const ModalBtn = styled.button`
//   appearance: none; border: none; border-radius: 14px; padding: 14px 24px; font-size: 0.95rem;
//   font-weight: 700; cursor: pointer; width: 100%; background: linear-gradient(135deg, #7c3aed, #8b5cf6);
//   color: white; &:hover { transform: translateY(-2px); }
// `;

// /* ================= STATES ================= */
// const CenterState = styled.div` min-height: 60vh; display: grid; place-items: center; padding: 24px; `;
// const StateCard = styled.div` width: min(460px, 100%); background: var(--card-bg); border: 1px solid var(--border); border-radius: 24px; padding: 28px; text-align: center; box-shadow: var(--shadow-md); `;
// const Spinner = styled.div` width: 46px; height: 46px; margin: 0 auto 18px; border-radius: 50%; border: 4px solid var(--border); border-top-color: #7c3aed; animation: spin 0.8s linear infinite; @keyframes spin { to { transform: rotate(360deg); } } `;
// const StateTitle = styled.h3` margin: 0 0 8px; font-size: 1.15rem; color: var(--text-main); font-weight: 700; `;
// const StateText = styled.p` margin: 10px 0 0; color: var(--text-soft); line-height: 1.6; `;



// /* ================= COMPONENT ================= */
// const WorkEthicLeadership = ({ user, collapsed, setCollapsed }) => {

//   const [loading, setLoading] = useState(true);
//   const [savedRecently, setSavedRecently] = useState(false);


//   // 🔥 GLOBAL THEME HOOK 🔥
//   const { isDarkMode } = useTheme(); 




//   // if (loading) {
//   //   return (
//   //     <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
//   //       <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//   //       <DashboardHeader title="Work Ethic & Leadership Attributes" />
//   //       <CenterState>
//   //         <StateCard>
//   //           <Spinner />
//   //           <StateTitle>Loading records</StateTitle>
//   //         </StateCard>
//   //       </CenterState>
//   //     </Container>
//   //   );
//   // }

//   return (
//     // 🔥 PASS THE THEME STATE TO THE CONTAINER 🔥
//     <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
//       <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//       <DashboardHeader user={user} collapsed={collapsed} title="Work Ethic & Leadership Attributes" />


//       <Main>
//         {/* <Hero> */}
//           <HeroPanel>
//             <HeroTitle>Messages</HeroTitle>
//           </HeroPanel>
//             {/* </Hero> */}
        

//       </Main>
//       <Footer />
//     </Container>
//   );
// };

// export default WorkEthicLeadership;




import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { FaPlay } from "react-icons/fa";
import Navbar from "./Navbar";
import DashboardHeader from "./DashboardHeader";
import Footer from "./Footer";
import { useTheme } from "../App"; 

/* ================= PAGE LAYOUT & THEME VARIABLES ================= */
const Container = styled.div`
  --sidebar-expanded: 260px;
  --sidebar-collapsed: 90px;
  
  --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
  --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.94)'};
  --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
  --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
  --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};

  min-height: 100vh;
  background: var(--page-bg);
  color: var(--text-main);
  margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
  transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;

  @media (max-width: 1024px) { margin-left: ${({ collapsed }) => (collapsed ? "78px" : "220px")}; }
  @media (max-width: 768px) { margin-left: 0; }
`;

const Main = styled.main`
  width: min(1380px, calc(100% - 32px));
  margin: 0 auto;
  padding: 12px 0 40px;
`;

const HeroPanel = styled.div`
  background: linear-gradient(135deg, #0f172a 0%, #312e81 50%, #7c3aed 100%);
  color: white;
  padding: 28px;
  border-radius: 28px;
  box-shadow: 0 22px 55px rgba(0, 0, 0, 0.15);
  margin-bottom: 32px;
`;

const HeroTitle = styled.h1`
  margin: 0;
  font-size: clamp(1.6rem, 1.2rem + 1.5vw, 2.5rem);
  font-weight: 800;
`;

/* ================= VIDEO GRID COMPONENTS ================= */
const VideoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
`;

const VideoCard = styled.div`
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 10px 20px rgba(0,0,0,0.05);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 30px rgba(124, 58, 237, 0.15);
    border-color: #8b5cf6;
  }
`;

const ThumbnailWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  background: #000;
`;

const Thumbnail = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9;
  transition: opacity 0.3s ease;

  ${VideoCard}:hover & {
    opacity: 1;
  }
`;

const PlayIconOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  background: rgba(124, 58, 237, 0.9); /* Purple */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  opacity: 0;
  transition: all 0.3s ease;

  ${VideoCard}:hover & {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.1);
  }
`;

const VideoInfo = styled.div`
  padding: 16px 20px;
`;

const VideoTitle = styled.h3`
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-main);
  line-height: 1.4;
`;

/* ================= MOCK DATA ================= */
const mockVideos = [
  { 
    id: 1, 
    title: "The Power of Leadership in Ministry", 
    thumb: "https://picsum.photos/id/1015/600/340", 
    url: "https://www.w3schools.com/html/mov_bbb.mp4" 
  },
  { 
    id: 2, 
    title: "Developing a Strong Work Ethic", 
    thumb: "https://picsum.photos/id/201/600/340", 
    url: "https://www.w3schools.com/html/mov_bbb.mp4" 
  },
  { 
    id: 3, 
    title: "Spreading Good News Effectively", 
    thumb: "https://picsum.photos/id/870/600/340", 
    url: "https://www.w3schools.com/html/mov_bbb.mp4" 
  },
];

/* ================= COMPONENT ================= */
const WorkEthicLeadership = ({ user, collapsed, setCollapsed }) => {
  const { isDarkMode } = useTheme(); 
  const navigate = useNavigate();

  const handleVideoClick = (video) => {
    // Navigate to the player page, passing the video details in state
    navigate(`/videoplayer/${video.id}`, { state: { video } });
  };

  return (
    <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
      <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
      <DashboardHeader user={user} collapsed={collapsed} title="Work Ethic & Leadership" />

      <Main>
        <HeroPanel>
          <HeroTitle>Messages & Training</HeroTitle>
        </HeroPanel>

        <VideoGrid>
          {mockVideos.map((video) => (
            <VideoCard key={video.id} onClick={() => handleVideoClick(video)}>
              <ThumbnailWrapper>
                <Thumbnail src={video.thumb} alt={video.title} />
                <PlayIconOverlay><FaPlay style={{ marginLeft: '4px' }} /></PlayIconOverlay>
              </ThumbnailWrapper>
              <VideoInfo>
                <VideoTitle>{video.title}</VideoTitle>
              </VideoInfo>
            </VideoCard>
          ))}
        </VideoGrid>
      </Main>
      <Footer />
    </Container>
  );
};

export default WorkEthicLeadership;